export default __webpack_public_path__ + "static/media/36.c3ae6705.jpeg";